import { render, staticRenderFns } from "./EnergySavingTips.vue?vue&type=template&id=f7dd1a92&scoped=true&"
import script from "./EnergySavingTips.vue?vue&type=script&lang=js&"
export * from "./EnergySavingTips.vue?vue&type=script&lang=js&"
import style0 from "./EnergySavingTips.vue?vue&type=style&index=0&id=f7dd1a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7dd1a92",
  null
  
)

export default component.exports